import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';
import { AppsConstants } from 'modules/userApps/store/constants';
import { IAppCountry } from '../actions';
export type CompanyPlan = 'CLASSIC' | 'PREMIUM' | 'ENTERPRISE';

export interface IAppLanguageData {
  language: string;
  name: string;
  description: string;
  benefits: string;
  functionality: string;
  // gallery: string[];
  // tutorialUrl: string;
  // privacyUrl: string;
}

export interface IDistributionInfo {
  id: string;
  allowedCountries: IAppCountry[];
  categories: string[];
  pricing: string;
  copyright: string;
  languages: IAppLanguageData[];
  gallery: string[];
  tutorialUrl: string;
  privacyUrl: string;
}

export const saveDistributionInfo = ({
  id,
  allowedCountries,
  categories,
  pricing,
  copyright,
  languages,
  gallery,
  privacyUrl,
  tutorialUrl,
}: IDistributionInfo): RequestAction => ({
  type: AppsConstants.APP_CHANGE_DISTRIBUTION,
  request: {
    query: gql`
      mutation(
        $id: ID
        $allowedCountries: [AppCountryPayload]
        $categories: [String]
        $galleryFiles: [String]
        $copyright: String
        $languages: [AppLanguageDataPayload]
        $privacyUrl: String
        $tutorialUrl: String
      ) {
        saveApp(
          app: {
            id: $id
            allowedCountries: $allowedCountries
            categories: $categories
            copyright: $copyright
            languages: $languages
            galleryFiles: $galleryFiles
            privacyUrl: $privacyUrl
            tutorialUrl: $tutorialUrl
          }
        ) {
          allowedCountries {
            country
            currencyCode
            activationFeePrice
            plans {
              name
              monthlyPrice
              description
              usageUnitPrice
              usageMinUnitPrice
              usageMaxUnitPrice
              includedUnits
            }
            trialUnits
            trialDays
            unitDescription
            unitDescriptionPlural
            priceDescription
          }
          categories
          copyright
          languages {
            language
            name
            description
            benefits
            functionality
          }
          gallery
          privacyUrl
          tutorialUrl
        }
      }
    `,
    variables: {
      id,
      allowedCountries,
      categories,
      pricing,
      copyright,
      languages,
      galleryFiles: gallery,
      privacyUrl,
      tutorialUrl,
    },
  },
  meta: {
    requestKey: id,
    mutations: {
      [AppsConstants.APP + id]: (data, { saveApp }) => ({ ...data, ...saveApp }),
    },
  },
});
